var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1014,
    height: 876,
    viewBox: "0 0 1014 876",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M569 869.001C611.5 913.001 971.469 715.086 1001 676.001C1030.53 636.916 1019.5 204 823.5 63C627.5 -78 0.79134 63 0.79134 63C0.79134 63 -5.66858 89.0567 18.3254 154.198C42.3194 219.34 58.9306 229.473 88.4616 252.635C117.993 275.796 220.428 301.853 241.654 333.7C262.879 365.547 250.091 375.68 264.857 414.765C279.622 453.85 275.668 424.898 284.105 481.354C292.542 537.811 304.539 546.496 304.539 546.496C304.539 546.496 284.358 651.391 330.5 676.001C376.642 700.61 508.5 763.001 508.5 763.001C508.5 763.001 526.5 825.001 569 869.001Z",
    fill: "#C6DE90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundo1);
export default __webpack_public_path__ + "static/media/fundo1.840445d1a8b4b8198566804aec571346.svg";
export { ForwardRef as ReactComponent };